import { render, staticRenderFns } from "./addWarningModal.vue?vue&type=template&id=773c420b&scoped=true"
import script from "./addWarningModal.vue?vue&type=script&lang=js"
export * from "./addWarningModal.vue?vue&type=script&lang=js"
import style0 from "./addWarningModal.vue?vue&type=style&index=0&id=773c420b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773c420b",
  null
  
)

export default component.exports